// Generates exam mark table
export const examMarkGenerator = max => {
	// Return empty result if max is less than 10, because
	// there should be atleast 10 segments
	if (max < 10) return [];

	// Store calculated values
	const result = [];

	// Calculate range for each mark
	const size = Math.floor(max / 10);

	// Calculate remainder from max
	let remainder = max % 10;

	for (let i = 0; i < 10; i++) {
		if (i === 0) {
			// Start value is 1 and end value is size plus one if
			// there's remainder or just size
			result.push({
				mark: i + 1,
				start: 1,
				end: remainder ? size + 1 : size
			});
			
			// Decrement remainder
			remainder -= 1;
		} else {
			// Start value is last mark's end value plus one
			const start = result[i - 1].end + 1;

			// End value is start value plus size if there's remainder
			// or start value plus size minus one
			const end = remainder > 0
				? start + size
				: start + (size - 1);

			// Decrement remainder
			remainder -= 1;

			// Append range to result
			result.push({
				mark: i + 1,
				start,
				end
			});
		}
	}

	return result;
};